<template>
    <v-form ref="fileImage">
        <v-file-input single-line :label="placeholder" :loading="loadingUpload" show-size :rules="fileRules"
            variant="outlined" v-model="files" multiple accept=".jpg, .png, .jpeg" prepend-icon="" hide-details>
            <template #append>
                <v-btn :loading="loadingUpload" @click="upload" variant="flat" color="primary">upload</v-btn>
            </template>
        </v-file-input>
    </v-form>

    <v-row class="ms-1">
        <v-col>
            <div class="pt-1">
                <div class="text-error text-caption" v-for="(errorMessage, i) in errorMessages" :key="i">
                    {{ errorMessage }}
                </div>
            </div>
            <v-input v-model="modelValue" :rules="rules">
                <template #message="{ message }">
                    <div>
                        {{ message }}
                    </div>
                </template>
            </v-input>
        </v-col>
    </v-row>

    <v-row class="mt-1">
        <template v-for="(url, index) in filesPreview" :key="index">
            <v-col cols="4">
                <v-img elevation="2" :src="url"></v-img>
            </v-col>
        </template>
    </v-row>

</template>

<script setup>
import api from "@/plugins/api";
import { computed, defineModel, defineProps, ref, watch } from "vue"
const modelValue = defineModel({
    required: true,
    type: Array,
    default: []
})
const props = defineProps({
    required: {
        type: Boolean,
        default: () => {
            return false
        },
        required: false
    },
    maxLength: {
        type: Number,
        required: false
    },
    placeholder: {
        type: String,
        required: false,
        default: ""
    }
})

const rules = computed(() => {
    return [
        (v) => {
            return !props.required || v?.length > 0 || "Silahkan upload gambar"
        },
    ]
})

const errorMessages = ref([])

const files = ref([])
const fileImage = ref()
const fileRules = computed(() => {
    return [
        (files) => {
            return !props.required || files?.length > 0 || "Silahkan upload gambar"
        },
        (files) => !files || !files.some(file => file.size > 2_097_152) || 'Ukuran file melebihi 2MB',
        (files) => !files || !files.some(file => !file || !["image/png", "image/jpg", "image/jpeg"].includes(file.type)) || 'Tipe file tidak sesuai'
    ]
})
const filesPreview = computed(() => {
    if (Array.isArray(files.value)) {
        return files.value.map(file => {
            return URL.createObjectURL(file)
        })
    }

    return []
})

watch(files, (value) => {
    if (value?.length <= 0 && modelValue.value?.length > 0) modelValue.value = []
})
watch(modelValue, (value) => {
    if (value?.length <= 0 && files.value?.length > 0) files.value = []
})

const loadingUpload = ref(false)
async function upload() {
    errorMessages.value = []
    const result = await fileImage.value.validate()

    if (result.errors.length > 0) {
        for (const error of result.errors) {
            errorMessages.value.push(...error.errorMessages)
        }
    }

    if (result.valid) {
        loadingUpload.value = true
        const formData = new FormData();

        if (files.value)
            for (const file of files.value) {
                formData.append("photos", file);
            }

        await api.post(
            "/upload/product-images",
            formData,
            {
                headers: {
                    "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
                },
            }
        ).then(response => {
            const imageUrls = response.data.response
            modelValue.value = imageUrls
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            loadingUpload.value = false
        })

    }
}
</script>

<style lang="scss" scoped></style>